import { render, staticRenderFns } from "./CreateClip.vue?vue&type=template&id=1ef21c8c&"
import script from "./CreateClip.vue?vue&type=script&lang=js&"
export * from "./CreateClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports